export default {
  candidate_list: "Candidate list",
};
